import { render, staticRenderFns } from "./CloudSave.vue?vue&type=template&id=8d485b30&scoped=true"
import script from "./CloudSave.vue?vue&type=script&lang=js"
export * from "./CloudSave.vue?vue&type=script&lang=js"
import style0 from "./CloudSave.vue?vue&type=style&index=0&id=8d485b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d485b30",
  null
  
)

export default component.exports